import {
  Box,
  Button,
  CircularProgress,
  PaginationItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
  FormGroup,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styles from "../../../styles/brsr/list.module.css";
import PaginationBox from "../../../Components/Masters/Pagination";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { api, get, put, post } from "../../../utils/api";
import { useGRI } from "../../../context/GRIContext";
import AddIcon from "@mui/icons-material/Add";
import Add from "../../../Components/Common/Add";
import {
  checkYear,
  currentYear,
  fiscalYear,
  getYearPeriods,
} from "../../../utils/generateYearRanges";
import useGRIStore from "../../../store/GRIstore";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import {
  griStructure,
  griStructure300,
  griStructure400,
} from "../../../utils/constant";
import GriGroup from "../GriGroup";
import CloseIcon from "@mui/icons-material/Close";

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.Mui-selected": {
    backgroundColor: "green",
    color: "#fff",
    fontWeight: "bold",
  },
  "&:hover": {
    backgroundColor: "#ededed",
  },
}));

const commonCellStyle = {
  padding: "8px",
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: "400",
  border: "1px solid #DBDBDB",
  color: "rgba(34, 34, 34, 1)",
};

const headerCellStyle = {
  ...commonCellStyle,
  fontWeight: "600",
  fontSize: "18px",
  whiteSpace: "nowrap",
  letterSpacing: "0.5px",
  color: "rgba(34, 34, 34, 1)",
};

const actionCellStyle = {
  ...commonCellStyle,
  textDecoration: "underline",
  cursor: "pointer",
};

const GriList = () => {
  const tableContainerRef = useRef(null);
  // const { setGriId } = useGRI();
  const navigate = useNavigate();

  const { setSelectedGRI } = useGRIStore();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentYearFilled, setCurrentYearFilled] = useState(false);

  const [activeFilter, setActiveFilter] = useState("All");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const [downloadingId, setDownloadingId] = useState(null);
  const [pdfGenerate, setPdfGenerate] = useState(false);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [griId, setGriId] = useState(null);

  const [expandedSections, setExpandedSections] = useState({
    generalDisclosure: false,
    series200: false,
    series300: false,
    series400: false,
  });

  // Initial structure for selectedPages
  const initialSelectedPages = {
    generalDisclosure: {
      all: false,
      pages: {
        general21: false,
        general22: false,
        general23: false,
        general24: false,
        general25: false,
        general26: false,
        general27: false,
        general28: false,
        general29: false,
        general210: false,
        general211: false,
        general212: false,
        general213: false,
        general214: false,
        general215: false,
        general216: false,
        general217: false,
        general218: false,
        general219: false,
        general220: false,
        general221: false,
        general222: false,
        general223: false,
        general224: false,
        general225: false,
        general226: false,
        general227: false,
        general228: false,
        general229: false,
        general230: false,
      },
    },
    series200: {
      all: false,
      pages: {
        gri201: {
          all: false,
          pages: {
            gri201_1: false,
            gri201_2: false,
            gri201_3: false,
            gri201_4: false,
          },
        },
        gri202: { all: false, pages: { gri202_1: false, gri202_2: false } },
        gri203: { all: false, pages: { gri203_1: false, gri203_2: false } },
        gri204: { all: false, pages: { gri204_1: false } },
        gri205: {
          all: false,
          pages: { gri205_1: false, gri205_2: false, gri205_3: false },
        },
        gri206: { all: false, pages: { gri206_1: false } },
        gri207: {
          all: false,
          pages: {
            gri207_1: false,
            gri207_2: false,
            gri207_3: false,
            gri207_4: false,
          },
        },
      },
    },
    series300: {
      all: false,
      pages: {
        gri301: {
          all: false,
          pages: { gri301_1: false, gri301_2: false, gri301_3: false },
        },
        gri302: {
          all: false,
          pages: {
            gri302_1: false,
            gri302_2: false,
            gri302_3: false,
            gri302_4: false,
            gri302_5: false,
          },
        },
        gri303: {
          all: false,
          pages: {
            gri303_1: false,
            gri303_2: false,
            gri303_3: false,
            gri303_4: false,
            gri303_5: false,
          },
        },
        gri304: {
          all: false,
          pages: {
            gri304_1: false,
            gri304_2: false,
            gri304_3: false,
            gri304_4: false,
          },
        },
        gri305: {
          all: false,
          pages: {
            gri305_1: false,
            gri305_2: false,
            gri305_3: false,
            gri305_4: false,
            gri305_5: false,
            gri305_6: false,
            gri305_7: false,
          },
        },
        gri306: {
          all: false,
          pages: {
            gri306_1: false,
            gri306_2: false,
            gri306_3: false,
            gri306_4: false,
            gri306_5: false,
          },
        },
        gri308: { all: false, pages: { gri308_1: false, gri308_2: false } },
      },
    },
    series400: {
      all: false,
      pages: {
        gri401: {
          all: false,
          pages: { gri401_1: false, gri401_2: false, gri401_3: false },
        },
        gri402: { all: false, pages: { gri402: false } },
        gri403: {
          all: false,
          pages: {
            gri403_1: false,
            gri403_2: false,
            gri403_3: false,
            gri403_4: false,
            gri403_5: false,
            gri403_6: false,
            gri403_7: false,
            gri403_8: false,
            gri403_9: false,
            gri403_10: false,
          },
        },
        gri404: {
          all: false,
          pages: { gri404_1: false, gri404_2: false, gri404_3: false },
        },
        gri405: { all: false, pages: { gri405_1: false, gri405_2: false } },
        gri413: { all: false, pages: { gri413_1: false, gri413_2: false } },
        gri414: { all: false, pages: { gri414_1: false, gri414_2: false } },
        gri416: { all: false, pages: { gri416_1: false, gri416_2: false } },
        gri417: {
          all: false,
          pages: { gri417_1: false, gri417_2: false, gri417_3: false },
        },
        gri406: { all: false, pages: { gri406: false } },
        gri407: { all: false, pages: { gri407: false } },
        gri408: { all: false, pages: { gri408: false } },
        gri409: { all: false, pages: { gri409: false } },
        gri410: { all: false, pages: { gri410: false } },
        gri411: { all: false, pages: { gri411: false } },
        gri415: { all: false, pages: { gri415: false } },
        gri418: { all: false, pages: { gri418: false } },
      },
    },
  };

  const [selectedPages, setSelectedPages] = useState(initialSelectedPages);

  const fetchData = async () => {
    try {
      const response = await get(`/gri/get/list?page=${page}&limit=10`);
      const fetchedData = response.data.data;
      setOriginalData(fetchedData);
      setData(fetchedData);
      setTotalPages(Math.ceil(fetchedData.length / 10));
      const { fiscalYearPeriod, calendarYearPeriod } = getYearPeriods();
      console.log(fetchedData, "fetchedData");
      const isPreviousYearFilled = fetchedData?.some(
        (el) =>
          el?.year?.includes(fiscalYearPeriod) ||
          el?.year?.includes(calendarYearPeriod)
      );

      if (isPreviousYearFilled) {
        setCurrentYearFilled(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  useEffect(() => {
    const newData = originalData.filter((item) => {
      if (activeFilter === "All") return true;
      return item.status === activeFilter;
    });
    setData(newData);
  }, [activeFilter, originalData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const [isShortContent, setIsShortContent] = useState(false);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const handleChange = async (id, status, value) => {
    localStorage.setItem("griReview", JSON.stringify(value));
    // // setGriId(id);
    // try {
    //   // const res1 =
    //   //   status &&
    //   //   (await put(`gri/grilist/update?id=${id}`, {
    //   //     status: status,
    //   //   }));

    //   setTimeout(() => {
    //     setSelectedGRI(id);
    navigate(`/gri/general-disclosure/2-1/${id}`);
    //   }, 2000);

    //   // console.log(res1, "url");
    // } catch (err) {
    //   console.log(err);
    // }
  };

  useEffect(() => {
    if (!pdfGenerate || !downloadingId) return;

    const intervalId = setInterval(async () => {
      try {
        console.log("pdfGenerate", pdfGenerate);
        const data = await get(`/gri/getCompletedGRI?id=${downloadingId}`);

        if (data?.data?.statusCode === 1) {
          //

          setPdfGenerate(false);
          if (data?.data?.data?.pdfUrl) {
            const url = data.data.data.pdfUrl;

            const res = await fetch(url);
            const blob = await res.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = "GRI_Report.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(blobUrl);
            setDownloadingId(null);
            setPreviewModalOpen(false);
            setSelectedPages(initialSelectedPages);
          }
        } else {
          console.log(data?.data?.data, "1223333");
        }
      } catch (error) {
        console.log(error, "errorinterval");
      }
    }, 60000);

    // Cleanup: clear interval when pdfGenerate becomes false or component unmounts
    return () => clearInterval(intervalId);
  }, [pdfGenerate, downloadingId]);

  const handleDownload = async (id) => {
    setDownloadingId(id);
    setsnackOpen({
      open: true,
      message: "Generating your report. This may take a moment",
      severity: "success",
    });

    try {
      const token = sessionStorage.getItem("token");

      const res = await fetch(`${api}/gri/generate-pdf?id=${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        throw new Error(
          "Failed to generate PDF. The server returned an error."
        );
      }

      // const blob = await res.blob();

      // const url = window.URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `BRSR_Report.pdf`;
      // document.body.appendChild(a);
      // a.click();
      // a.remove();
      // window.URL.revokeObjectURL(url);

      setsnackOpen({
        open: true,
        message: "Your download has started!",
        severity: "success",
      });
    } catch (err) {
      console.error(err);
      setsnackOpen({
        open: true,
        message:
          err.message || "Failed to generate PDF. Please try again later.",
        severity: "error",
      });
    } finally {
      setDownloadingId(null);
    }
  };

  const handlePreview = (id) => {
    navigate(
      `/gri/preview-download/${id}?autoDownload=true&returnTo=${encodeURIComponent(
        "/gri"
      )}`
    );
  };

  const toggleSectionExpand = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section],
    });
  };

  const handleParentCheckboxChange = (section) => (e) => {
    const isChecked = e.target.checked;

    // Recursively walk the pages tree
    const toggleTree = (node) => {
      if (typeof node === "boolean") return isChecked; // leaf
      if (node && typeof node === "object") {
        const out = {};
        Object.entries(node).forEach(([k, v]) => {
          if (k === "all") {
            out[k] = isChecked;
          } else {
            out[k] = toggleTree(v);
          }
        });
        return out;
      }
      return node;
    };

    setSelectedPages((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        all: isChecked,
        pages: toggleTree(prev[section].pages),
      },
    }));
  };

  const generalDisclosurePages = Array.from(
    { length: 30 },
    (_, i) => `general2${i + 1}`
  );

  const handleChildCheckboxChange = (section, page) => (e) => {
    const isChecked = e.target.checked;
    const updatedPages = {
      ...selectedPages[section].pages,
      [page]: isChecked,
    };

    const anyChecked = Object.values(updatedPages).some((val) => val);
    setSelectedPages({
      ...selectedPages,
      [section]: {
        all: anyChecked,
        pages: updatedPages,
      },
    });
  };

  const formatGeneralDisclosure = (pageKey) => {
    const num = pageKey.replace("general", ""); // e.g., "21"
    return `${num[0]}-${num.slice(1)}`; // e.g., "2-1"
  };

  const handleNestedParentCheckboxChange = (section, subsection) => (e) => {
    const isChecked = e.target.checked;

    const pageKeys = Object.keys(
      selectedPages[section].pages[subsection].pages
    );

    const updatedPages = pageKeys.reduce((acc, page) => {
      acc[page] = isChecked;
      return acc;
    }, {});

    const updatedGroups = {
      ...selectedPages[section].pages,
      [subsection]: {
        all: isChecked,
        pages: updatedPages,
      },
    };

    const isAnyPageCheckedInSection = Object.values(updatedGroups).some(
      (group) => Object.values(group.pages).some(Boolean)
    );

    setSelectedPages({
      ...selectedPages,
      [section]: {
        all: isAnyPageCheckedInSection,
        pages: updatedGroups,
      },
    });
  };

  const handleNestedChildCheckboxChange =
    (section, subsection, page) => (e) => {
      const isChecked = e.target.checked;

      const currentGroup = selectedPages[section].pages[subsection];
      const updatedPages = {
        ...currentGroup.pages,
        [page]: isChecked,
      };

      const isAnyPageCheckedInSubsection =
        Object.values(updatedPages).some(Boolean);

      const updatedSubsection = {
        ...currentGroup,
        all: isAnyPageCheckedInSubsection,
        pages: updatedPages,
      };

      const updatedGroups = {
        ...selectedPages[section].pages,
        [subsection]: updatedSubsection,
      };

      const isAnyPageCheckedInSection = Object.values(updatedGroups).some(
        (group) => Object.values(group.pages).some(Boolean)
      );

      setSelectedPages({
        ...selectedPages,
        [section]: {
          all: isAnyPageCheckedInSection,
          pages: updatedGroups,
        },
      });
    };

  const handleDownloadGri = async (id) => {
    setDownloadingId(id);
    setsnackOpen({
      open: true,
      message: "Generating your report. This may take a moment",
      severity: "success",
    });

    try {
      const token = sessionStorage.getItem("token");

      const res = await fetch(`${api}/gri/generate-pdf?id=${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ selectedPages }),
      });

      setPdfGenerate(true);
      if (!res.ok) {
        throw new Error(
          "Failed to generate PDF. The server returned an error."
        );
      }

      setsnackOpen({
        open: true,
        message: "Your download has started!",
        severity: "success",
      });
    } catch (err) {
      console.error(err);
      setsnackOpen({
        open: true,
        message:
          err.message || "Failed to generate PDF. Please try again later.",
        severity: "error",
      });
      setDownloadingId(null);
      setPdfGenerate(false);
    }
  };

  return (
    <>
      {/* Full-page loader overlay */}
      {downloadingId && griId && downloadingId === griId && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.35)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              bgcolor: "white",
              p: 4,
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <CircularProgress size={48} sx={{ mb: 2 }} />
            <Typography variant="h6" sx={{ color: "#1C486B" }}>
              Generating your report...
            </Typography>
          </Box>
        </div>
      )}
      <p className={styles.heading}>GRI</p>
      {/* <p className={styles.subheading}>
        To change how frequently you want to create GRI data, navigate to the
        Settings.
      </p> */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <div className={styles.filter_buttons}>
          {["All", "Pending", "Completed", "In Progress"].map((filter) => (
            <button
              key={filter}
              variant="contained"
              className={
                activeFilter === filter
                  ? styles["active_button"]
                  : styles["inactive_button"]
              }
              onClick={() => handleFilterChange(filter)}
            >
              {filter}
            </button>
          ))}
        </div>
        <Button
          // disabled={currentYearFilled}
          variant="contained"
          endIcon={<AddIcon />}
          sx={{
            backgroundColor: "#1c486b",
            fontSize: "16px",
            textTransform: "none",
            fontFamily: "Inter",
            fontWeight: "500",
            height: "2.5rem",
            mt: "2rem",
            "&:hover": {
              backgroundColor: "#1c486b",
              opacity: 0.9,
            },
          }}
          onClick={() => setIsModalOpen(true)}
        >
          Add New
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        ref={tableContainerRef}
        style={{ marginTop: "1.5rem", backgroundColor: "#FCFCFC" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {[
                "S.No",
                "Reporting Period",
                "Reporting Year",
                "Create Date",
                "Status",
                "Action",
                "Download",
              ].map((header, index) => (
                <TableCell key={index} style={headerCellStyle}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <Add
            handleClose={() => setIsModalOpen(false)}
            title=" GRI Report"
            addData={isModalOpen}
            // id={row?._id}
            addUrl={`/gri/add`}
            updateUrl={`gri/grilist/update`}
            {...{
              setsnackOpen,
              fetchData,
              data,
            }}
          />
          <TableBody className={styles.table_body}>
            {data && data.length > 0 ? (
              data?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell style={commonCellStyle}>
                    {(page - 1) * 10 + rowIndex + 1}
                  </TableCell>
                  <TableCell style={commonCellStyle}>{row?.period}</TableCell>
                  <TableCell style={commonCellStyle}>{row?.year}</TableCell>
                  <TableCell style={commonCellStyle}>
                    {new Date(row?.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </TableCell>
                  <TableCell
                    style={{
                      ...commonCellStyle,
                      color:
                        row?.status === "Pending"
                          ? "#FF4444"
                          : row?.status === "In Progress"
                          ? "#FFBB33"
                          : "#488257",
                    }}
                  >
                    {row?.status}
                  </TableCell>
                  <TableCell style={actionCellStyle}>
                    {
                      // checkYear(row?.year)
                      // ?
                      row?.status === "Pending" ? (
                        <Typography
                          onClick={() => handleChange(row?._id, "", true)}
                        >
                          Start
                        </Typography>
                      ) : row?.status === "In Progress" ? (
                        <Typography
                          onClick={() => handleChange(row?._id, "", true)}
                        >
                          Continue{" "}
                        </Typography>
                      ) : (
                        <Box sx={{ display: "flex", gap: 1 }}>
                          {/* <Typography
                          onClick={() =>
                            handleChange(row?._id, "Completed", false)
                          }
                        >
                          View /
                        </Typography> */}
                          {/* <Typography
                          onClick={() => {
                            localStorage.setItem(
                              "griReview",
                              JSON.stringify(false)
                            );
                            navigate(`/gri/preview/${row?._id}`);
                          }}
                        >
                          View /
                        </Typography> */}
                          <Typography
                            onClick={() =>
                              handleChange(row?._id, "Completed", false)
                            }
                          >
                            {" "}
                            Edit
                          </Typography>
                          {/* <Typography
                          onClick={()=>navigate(`/gri/download/${row?._id}`)
                          }
                        >
                          {" "}
                          Download
                        </Typography> */}
                        </Box>
                      )
                      //   : <Typography
                      //   onClick={() => {
                      //     localStorage.setItem(
                      //       "griReview",
                      //       JSON.stringify(false)
                      //     );
                      //     navigate(`/gri/preview/${row?._id}`);
                      //   }}
                      // >
                      //   View
                      // </Typography>
                    }
                  </TableCell>
                  {/* <TableCell
                    style={{
                      ...actionCellStyle,
                      cursor: downloadingId ? "not-allowed" : "pointer",
                      opacity:
                        downloadingId && downloadingId !== row._id ? 0.5 : 1,
                    }}
                    onClick={() => !downloadingId && handleDownload(row?._id)}
                  >
                    {downloadingId === row._id ? (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <CircularProgress size={16} sx={{ mr: 1 }} />
                        Generating...
                      </Box>
                    ) : (
                      "Download"
                    )}
                  </TableCell> */}
                  {row?.status === "Completed" ? (
                    <TableCell
                      style={actionCellStyle}
                      onClick={() => handlePreview(row?._id)}
                    >
                      Preview 
                    </TableCell>
                  ) : (
                    <TableCell>
                      <p style={{ margin: 0, padding: 0 }}>-</p>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} style={{ textAlign: "center" }}>
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {totalPages > 1 && (
        <PaginationBox
          isShortContent={isShortContent}
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )}

      {/* Preview Modal */}
      <Dialog
        open={previewModalOpen}
        onClose={() => setPreviewModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2, position: "relative" }}>
          Select Sections to be included in downloaded GRI Report
          <IconButton
            aria-label="close"
            onClick={() => setPreviewModalOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: 2,
            }}
          >
            <Box>
              <Box
                sx={{
                  mb: 3,
                  p: 3,
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
              >
                <FormGroup>
                  {/* General Disclosure Section */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedPages.generalDisclosure.all}
                          onChange={handleParentCheckboxChange(
                            "generalDisclosure"
                          )}
                          sx={{
                            "&.Mui-checked": {
                              color: "#1c486b",
                            },
                          }}
                        />
                      }
                      label="General Disclosure 2021"
                      sx={{ flex: 1, marginRight: 2 }}
                    />
                    <IconButton
                      onClick={() => toggleSectionExpand("generalDisclosure")}
                      size="small"
                      sx={{}}
                    >
                      <ExpandCircleDownIcon
                        style={{
                          transform: expandedSections.generalDisclosure
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                          color: "#666666",
                        }}
                      />
                    </IconButton>
                  </Box>
                  <Collapse in={expandedSections.generalDisclosure}>
                    <Box
                      sx={{ ml: 4, display: "flex", flexDirection: "column" }}
                    >
                      {generalDisclosurePages.map((pageKey) => (
                        <FormControlLabel
                          key={pageKey}
                          control={
                            <Checkbox
                              checked={
                                selectedPages.generalDisclosure.pages[
                                  pageKey
                                ] || false
                              }
                              onChange={handleChildCheckboxChange(
                                "generalDisclosure",
                                pageKey
                              )}
                              sx={{
                                "&.Mui-checked": {
                                  color: "#1c486b",
                                },
                              }}
                            />
                          }
                          label={`General Disclosure ${formatGeneralDisclosure(
                            pageKey
                          )}`}
                        />
                      ))}
                    </Box>
                  </Collapse>

                  {/* 200 Series Section */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedPages.series200.all}
                          onChange={handleParentCheckboxChange("series200")}
                          sx={{
                            "&.Mui-checked": {
                              color: "#1c486b",
                            },
                          }}
                        />
                      }
                      label={griStructure.series200.label}
                      sx={{ flex: 1, marginRight: 2 }}
                    />
                    <IconButton
                      onClick={() => toggleSectionExpand("series200")}
                      size="small"
                      sx={{}}
                    >
                      <ExpandCircleDownIcon
                        style={{
                          transform: expandedSections.series200
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                          color: "#666666",
                        }}
                      />
                    </IconButton>
                  </Box>
                  <Collapse in={expandedSections.series200}>
                    <Box sx={{ ml: 4 }}>
                      {Object.entries(griStructure.series200.groups).map(
                        ([groupKey, groupData]) => (
                          <GriGroup
                            key={groupKey}
                            seriesKey="series200"
                            groupKey={groupKey}
                            groupData={groupData}
                            selectedPages={selectedPages}
                            expandedSections={expandedSections}
                            toggleSectionExpand={toggleSectionExpand}
                            handleNestedParentCheckboxChange={
                              handleNestedParentCheckboxChange
                            }
                            handleNestedChildCheckboxChange={
                              handleNestedChildCheckboxChange
                            }
                          />
                        )
                      )}
                    </Box>
                  </Collapse>

                  {/* 300 Series Section */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedPages.series300.all}
                          onChange={handleParentCheckboxChange("series300")}
                          sx={{
                            "&.Mui-checked": {
                              color: "#1c486b",
                            },
                          }}
                        />
                      }
                      label="300 Series "
                      sx={{ flex: 1, marginRight: 2 }}
                    />
                    <IconButton
                      onClick={() => toggleSectionExpand("series300")}
                      size="small"
                      sx={{}}
                    >
                      <ExpandCircleDownIcon
                        style={{
                          transform: expandedSections.series300
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                          color: "#666666",
                        }}
                      />
                    </IconButton>
                  </Box>
                  <Collapse in={expandedSections.series300}>
                    <Box sx={{ ml: 4 }}>
                      {Object.entries(griStructure300.series300.groups).map(
                        ([groupKey, groupData]) => (
                          <GriGroup
                            key={groupKey}
                            seriesKey="series300"
                            groupKey={groupKey}
                            groupData={groupData}
                            selectedPages={selectedPages}
                            expandedSections={expandedSections}
                            toggleSectionExpand={toggleSectionExpand}
                            handleNestedParentCheckboxChange={
                              handleNestedParentCheckboxChange
                            }
                            handleNestedChildCheckboxChange={
                              handleNestedChildCheckboxChange
                            }
                          />
                        )
                      )}
                    </Box>
                  </Collapse>

                  {/* 400 Series Section */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedPages.series400.all}
                          onChange={handleParentCheckboxChange("series400")}
                          sx={{
                            "&.Mui-checked": {
                              color: "#1c486b",
                            },
                          }}
                        />
                      }
                      label="400 Series "
                      sx={{ flex: 1, marginRight: 2 }}
                    />
                    <IconButton
                      onClick={() => toggleSectionExpand("series400")}
                      size="small"
                      sx={{}}
                    >
                      <ExpandCircleDownIcon
                        style={{
                          transform: expandedSections.series400
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                          color: "#666666",
                        }}
                      />
                    </IconButton>
                  </Box>
                  <Collapse in={expandedSections.series400}>
                    <Box sx={{ ml: 4 }}>
                      {Object.entries(griStructure400.series400.groups).map(
                        ([groupKey, groupData]) => (
                          <GriGroup
                            key={groupKey}
                            seriesKey="series400"
                            groupKey={groupKey}
                            groupData={groupData}
                            selectedPages={selectedPages}
                            expandedSections={expandedSections}
                            toggleSectionExpand={toggleSectionExpand}
                            handleNestedParentCheckboxChange={
                              handleNestedParentCheckboxChange
                            }
                            handleNestedChildCheckboxChange={
                              handleNestedChildCheckboxChange
                            }
                          />
                        )
                      )}
                    </Box>
                  </Collapse>
                </FormGroup>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              onClick={() => handleDownloadGri(griId)}
              sx={{
                bgcolor: "#1C486B",
                textTransform: "none",
                height: "3rem",
                color: "white",
                "&:hover": { bgcolor: "#0D3A5A" },
              }}
              variant="contained"
              disabled={downloadingId === griId}
            >
              {downloadingId === griId ? (
                <>
                  <CircularProgress size={22} sx={{ color: "white", mr: 1 }} />{" "}
                  Generating...
                </>
              ) : (
                "Download"
              )}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GriList;